import { cn } from "@/lib/cn";

// Shared status pill — same colour tokens the prototype used so we can
// switch to a real API later without touching screens.
const PALETTE: Record<string, string> = {
  draft:      "bg-bg-2 text-fg-3",
  proof:      "bg-[#FBEFD8] text-[#6B4200]",
  approved:   "bg-[#E3F2EA] text-[color:var(--ok)]",
  production: "bg-[#E0EFF5] text-[#177FA9]",
  shipped:    "bg-[#E2F1EF] text-[color:var(--brand-teal)]",
  delivered:  "bg-[#E3F2EA] text-[color:var(--ok)]",
  cancelled:  "bg-bg-2 text-fg-3",
  hold:       "bg-[var(--admin-tint)] text-[var(--admin-dark)]",
  active:     "bg-[#E3F2EA] text-[color:var(--ok)]",
  pending:    "bg-[#FBEFD8] text-[#6B4200]",
  suspended:  "bg-bg-2 text-fg-3",
  invited:    "bg-[#E0EFF5] text-[#177FA9]",
};

export function StatusPill({ status, className }: { status: string; className?: string }) {
  const tone = PALETTE[status] ?? "bg-bg-2 text-fg-3";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-2xs font-semibold capitalize tracking-tight",
        tone,
        className,
      )}
    >
      <span className="h-1 w-1 rounded-full bg-current" aria-hidden />
      {status.replace(/_/g, " ")}
    </span>
  );
}
